const stateKey = 'app.dash.state';

/**
 * Use of local storage can fail if the user has disabled permission for the browser to use that feature
 */

export const loadState = () => {
  try {
    const serialized = localStorage.getItem(stateKey);
    if (serialized === null) {
      return {};
    }

    return JSON.parse(serialized);
  } catch (e) {
    console.log('Failed to load application state', e);
    return {};
  }
};

export const persistState = state => {
  try {
    const serialized = JSON.stringify(state);
    localStorage.setItem(stateKey, serialized);
  } catch (e) {
    //log and continue
    console.log('Failed to persist application state', e);
  }
};
